import { FormattedTime } from "react-intl";

import useGetMyTimeWithTimezoneAbbreviation from "@hooks/useGetMyTimeWithTimezoneAbbreviation";

type Props = {
  includeTimezone?: boolean;
  value: Date;
};

const TimeStamp = ({ includeTimezone = false, value }: Props) => {
  const getMyTimeWithTimezoneAbbreviation = useGetMyTimeWithTimezoneAbbreviation();

  return <>{includeTimezone ? getMyTimeWithTimezoneAbbreviation(value) : <FormattedTime value={value} />}</>;
};

export default TimeStamp;
